export const getItemInArrayByID = (array: any[], field: "name" | "fullname" | "surname", id: number): string | null => {
    const inx = array.findIndex(item => item.id === id && field in item);
                    
    if(inx > -1) {
        return String(array[inx][field]);
    }
    
    return null;
}